"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Priority_4_Operator = exports.Priority_3_Operator = exports.Priority_2_Operator = exports.Priority_1_Operator = exports.AllOperators = exports.Operators = exports.ArithmeticOperator = exports.ComparisonOperator = exports.BackslashOperator = exports.QuestionMarkOperator = exports.ColonOperator = exports.ParenthesisCloseOperator = exports.ParenthesisOpenOperator = exports.AssignmentOperator = exports.NotEqualOperator = exports.EqualOperator = exports.LessThanOrEqualOperator = exports.GreaterThanOrEqualOperator = exports.LessThanOperator = exports.GreaterThanOperator = exports.LogicalOrOperator = exports.LogicalAndOperator = exports.ModuloOperator = exports.ExponentialOperator = exports.MultiplicationOperator = exports.DivisionOperator = exports.SubtractionOperator = exports.AdditionOperator = exports.ConditionResult = exports.REGEX = void 0;
/**
 * Regular expressions used for parsing formula expressions.
 */
exports.REGEX = {
    /** Global regex for matching operators in formulas */
    formulaOperatorG: /(<=|\^|%|>=|==|\|\||&&|!=|[+/\-*=()<>?:])/g,
    /** Single match regex for operators */
    formulaOperator: /(<=|>=|\^|%|==|\|\||&&|!=|[+/\-*=()<>?!:])/,
    /** Regex to identify formula field names (prefixed with 'f_') */
    formulaFieldName: /f_[\w]/, // that is regex that identify the formula fieldName
};
/**
 * Enumeration for boolean condition results in expressions.
 * Used for ternary operations and logical evaluations.
 */
exports.ConditionResult = {
    /** Represents true (evaluates to 1 in numeric context) */
    True: 1,
    /** Represents false (evaluates to 0 in numeric context) */
    False: 0,
};
// Arithmetic operators
/** Addition operator (+) */
exports.AdditionOperator = "+";
/** Subtraction operator (-) */
exports.SubtractionOperator = "-";
/** Division operator (/) */
exports.DivisionOperator = "/";
/** Multiplication operator (*) */
exports.MultiplicationOperator = "*";
/** Exponential operator (^) */
exports.ExponentialOperator = "^";
/** Modulo operator (%) */
exports.ModuloOperator = "%";
// Logical operators
/** Logical AND operator (&&) */
exports.LogicalAndOperator = "&&";
/** Logical OR operator (||) */
exports.LogicalOrOperator = "||";
// Comparison operators
/** Greater than operator (>) */
exports.GreaterThanOperator = ">";
/** Less than operator (<) */
exports.LessThanOperator = "<";
/** Greater than or equal operator (>=) */
exports.GreaterThanOrEqualOperator = ">=";
/** Less than or equal operator (<=) */
exports.LessThanOrEqualOperator = "<=";
/** Equality operator (==) */
exports.EqualOperator = "==";
/** Inequality operator (!=) */
exports.NotEqualOperator = "!=";
// Other operators
/** Assignment operator (=) */
exports.AssignmentOperator = "=";
/** Opening parenthesis (() */
exports.ParenthesisOpenOperator = "(";
/** Closing parenthesis ()) */
exports.ParenthesisCloseOperator = ")";
/** Colon operator (:) - used in ternary operations */
exports.ColonOperator = ":";
/** Question mark operator (?) - used in ternary operations */
exports.QuestionMarkOperator = "?";
/** Backslash operator (\) */
exports.BackslashOperator = "\\";
/** Array of all comparison operators */
exports.ComparisonOperator = [
    exports.GreaterThanOperator,
    exports.LessThanOperator,
    exports.LogicalOrOperator,
    exports.LogicalAndOperator,
    exports.GreaterThanOrEqualOperator,
    exports.LessThanOrEqualOperator,
    exports.EqualOperator,
    exports.NotEqualOperator,
];
/** Array of all arithmetic operators */
exports.ArithmeticOperator = [
    exports.AdditionOperator,
    exports.SubtractionOperator,
    exports.DivisionOperator,
    exports.MultiplicationOperator,
    exports.ExponentialOperator,
    exports.ModuloOperator,
];
/** Combined array of arithmetic and comparison operators plus ternary operator */
exports.Operators = [
    ...exports.ArithmeticOperator,
    ...exports.ComparisonOperator,
    exports.QuestionMarkOperator,
];
/** Array of all operators including parentheses and colon */
exports.AllOperators = [
    ...exports.Operators,
    exports.ColonOperator,
    exports.ParenthesisCloseOperator,
    exports.ParenthesisOpenOperator,
];
/** Priority 1 operators (lowest precedence): addition and subtraction */
exports.Priority_1_Operator = [exports.AdditionOperator, exports.SubtractionOperator];
/** Priority 2 operators: multiplication, division, modulo */
exports.Priority_2_Operator = [
    exports.DivisionOperator,
    exports.MultiplicationOperator,
    exports.ModuloOperator,
];
/** Priority 3 operators (highest precedence): exponentiation */
exports.Priority_3_Operator = [exports.ExponentialOperator];
/** Priority 4 operators: comparisons and ternary */
exports.Priority_4_Operator = [
    ...exports.ComparisonOperator,
    exports.QuestionMarkOperator,
];
